export default "__VITE_ASSET__B0n3Rk_W__"